import { useMemo } from "react";
import Fuse from "fuse.js/dist/fuse.basic";

import { flattenLeaves, growFromLeaves, transformTree } from "../utils/tree";

export function useFuseSearch(options) {
  const leaves = useMemo(() => flattenLeaves(options), [options]);
  const fuse = useMemo(
    () =>
      new Fuse(leaves, {
        keys: ["label"],
        threshold: 0.3,
      }),
    [options]
  );
  function search(filter) {
    if (filter.length > 2) {
      let results = fuse.search<TODO>(filter);

      const transformFunc = (node) => ({ ...node.item });
      results = transformTree(results, transformFunc);

      return growFromLeaves(results);
    } else {
      return [];
    }
  }
  return search;
}
